import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { EncryService } from '../servicos/crypt/encry.service';

export interface UserProfile {
  Tipo: string;
  empresa_id: number;
  AcessoFull: boolean;
  is_superuser: boolean;
}

@Injectable({ providedIn: 'root' })
export class ConfiguracoesService {

  constructor(
    private http: HttpClient,
    private encDecService: EncryService,
  ) {}

  private get baseUrl(): string {
    return localStorage.getItem('serverMaster') ?? `${window.location.origin}/`;
  }

  private httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: `Token ${this.encDecService.get('123456$#@$^@1ERF', localStorage.getItem('token'))}`,
      }),
    };
  }

  getPerfil(): Observable<UserProfile> {
    return this.http.get<UserProfile>(`${this.baseUrl}api/v2/usuarios/me/`, this.httpOptions());
  }

  aplicarAlteracoes(empresaId: number): Observable<{ status: string; arquivos: string[] }> {
    return this.http.post<{ status: string; arquivos: string[] }>(
      `${this.baseUrl}api/v2/reload-empresa/`,
      { empresa_id: empresaId },
      this.httpOptions(),
    );
  }
}
